import React from "react";
import ReactGA from "react-ga4";
import {
  useLocation,
  useParams,
  useNavigate,
  Navigate,
} from "react-router-dom";
import request from "../../../utilities/requests";
import {
  Grid,
  Card,
  Avatar,
  CircularProgress,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "../../../utilities/SnackBarUtils";

const EventResults = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: eventId } = useParams();
  // const [event, setEvent] = React.useState(null);
  const eventFromState = location.state?.event;
  const effectiveEventId = eventFromState?._id ?? eventId;
  console.log("EventResults check", { eventId, stateEvent: eventFromState, effectiveEventId });
  const [eventName, setEventName] = React.useState("");
  const [pairings, setPairings] = React.useState([]);
  const [pairingEventType, setPairingEventType] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [showFeedback, setShowFeedback] = React.useState(false);
  const [feedback, setFeedback] = React.useState(null);

  const noStateNoParam = !effectiveEventId;

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/eventresults",
      title: "EventResults",
    });
  }, []);

  React.useEffect(() => {
    if (!effectiveEventId) return;

    if (eventFromState) {
      setEventName(eventFromState.name);
    }

    getPairings(effectiveEventId);
  }, [effectiveEventId, eventFromState]);

  const getPairings = async (eventId) => {
    const result = await request(`pairing/results?eventId=${eventId}`);
    if (result.success) {
      setPairings(result.pairings);
      setEventName(result.eventName);
      setPairingEventType(result?.pairingEventType);
      setShowFeedback(result.showFeedback);
    }
    setLoaded(true);
  };

  const handleFeedback = async (pairingId, val) => {
    setFeedback(val);
    const body = { pairingId, feedback: val };
    const result = await request("pairing/leavefeedback", "post", body);
    if (result.success) {
      toast.success(result.message);
      getPairings(effectiveEventId);
    }
  };

  const renderMatches = () => {
    return pairings.map((pairing) => {
      return (
        <Grid key={pairing._id} item style={{ marginBottom: 20 }}>
          <Card sx={{ width: 345 }}>
            <Grid
              container
              direction="column"
              alignItems="center"
              spacing={1}
              style={{ padding: 20 }}
            >
              <Grid item>
                <Typography gutterBottom variant="h6" component="div">
                  Round {pairing.round}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  src={pairing?.profileImageUrl}
                  style={{ width: 120, height: 120 }}
                />
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1" component="div">
                  {pairing.firstName}
                </Typography>
              </Grid>
              {pairingEventType === "friend" ? (
                <></>
              ) : (
                <Grid
                  item
                  style={{
                    display: "flex",
                    direction: "row",
                    justifyContent: "center",
                  }}
                >
                  <Typography gutterBottom variant="body1" component="div">
                    Match:
                  </Typography>
                  {pairing?.match ? (
                    <CheckIcon style={{ color: "#68C371" }} />
                  ) : (
                    <CloseIcon style={{ color: "#E36262" }} />
                  )}
                </Grid>
              )}

              <Grid item>
                <Typography gutterBottom variant="body2" component="div">
                  {pairing?.notes}
                </Typography>
              </Grid>
              {showFeedback ? (
                <Grid item style={{ width: "100%" }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id={`feedback-label-${pairing._id}`}>
                      Have you been in touch?
                    </InputLabel>
                    <Select
                      labelId={`feedback-label-${pairing._id}`}
                      id={`feedback-select-${pairing._id}`}
                      value={pairing?.feedback || ""}
                      label="Have you been in touch?"
                      onChange={(e) =>
                        handleFeedback(pairing._id, e.target.value)
                      }
                    >
                      <MenuItem value="noResponse">No response</MenuItem>
                      <MenuItem value="inContact">In contact</MenuItem>
                    </Select>
                    <Typography variant="caption">
                      Responses will not be shared with your match
                    </Typography>
                  </FormControl>
                </Grid>
              ) : null}
            </Grid>
          </Card>
        </Grid>
      );
    });
  };

  if (noStateNoParam) {
    return <Navigate to="/" replace />;
  }

  if (!loaded) {
    return (
      <div
        style={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress style={{ height: 100, width: 100 }} />
      </div>
    );
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={3}
      style={{ marginBottom: 50, padding: "20px 20px 200px 20px" }}
    >
      <Grid item>
        <Typography variant="h5" align="center">
          {eventName}
        </Typography>
      </Grid>
      {pairings.length > 0 ? (
        renderMatches()
      ) : (
        <Grid item>
          <Typography align="center">
            Unfortunately you did not have any matches for this event.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default EventResults;
